//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailRole from "@/views/Setting/RoleManagement/components/DetailRole";
export default {
  name: "RoleList",
  props: {
    systemType: {
      type: Number,
      default: 3,
    },
  },
  components: { DetailRole },
  data() {
    return {
      roles: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      loadRoles: false,
      dialogRoleDetailVisible: false,
      curRoleDetail: {},
      masterId: "",
    };
  },
  created() {
    let { $businessAccountId } = this.$route.query;
    this.masterId = $businessAccountId;
    this.getRoleList();
  },
  computed: {},
  methods: {
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-06-07 14:42:19
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.pagination.page = val;
      // this.getBdOrderList();
    },
    /**
     * @description: 查看详情
     * @Author: yangsibo
     * @Date: 2022-06-06 14:50:28
     * @param {*} id 角色id
     */
    toDetail(item) {
      this.curRoleDetail = item;
      this.dialogRoleDetailVisible = true;
    },
    /**
     * @description: 获取角色列表
     * @Author: yangsibo
     * @Date: 2022-05-23 17:45:52
     * @return {*}
     */
    async getRoleList() {
      this.loadRoles = true;
      this.roles = [];
      try {
        let { data } = await this.$http.role.getSRoleListNum({
          ...this.pagination,
          systemType: this.systemType,
          masterId: this.masterId,
        });
        if (data) {
          let { recordTotal, content: roles } = data;
          this.pagination.recordTotal = recordTotal;
          this.roles = roles;
        }
        this.loadRoles = false;
      } catch (error) {
        this.loadRoles = false;
      }
    },
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-06-09 10:50:18
     * @return {*}
     */
    close() {
      this.dialogRoleDetailVisible = false;
    },
  },
  mounted() {},
};
